import React from "react";
import { graphql } from "gatsby";
import LcArticleLayout from "@components/learningCenter/lcArticleLayout";
import LcChildLinksBlock from "@components/learningCenter/lcChildLinksBlock";
import { SeoMetadata } from "@components/shared/seoMetadata";
import { generateArticleSchema } from "@utils/lcArticleSchema";

const generateChildLinks = (subcategory) => {
  return (subcategory.items || []).map((item) => {
    return { title: item.title, path: `/learn/${item.slug}/` };
  });
};

export default function LcSubcategory({ data, pageContext }) {
  const { contentfulLcSubcategory: subcategory } = data;
  const sectionSlug = subcategory.lc_category[0].lc_section[0].slug;
  const childLinks = generateChildLinks(subcategory);

  const body = subcategory?.coverArticle?.body;
  const metaDescription = subcategory?.coverArticle?.metaDescription?.metaDescription;
  const metaTitle = subcategory?.coverArticle?.metaTitle;

  return (
    <LcArticleLayout
      title={subcategory.title}
      body={body}
      metaDescription={metaDescription}
      metaTitle={metaTitle}
      appendBlock={<LcChildLinksBlock links={childLinks} useSeparator={sectionSlug !== "getting-started"} />}
      {...pageContext}
    />
  );
}

export function Head({ data }) {
  const { contentfulLcSubcategory: subcategory } = data;
  const coverArticle = subcategory?.coverArticle;

  let articleSchema = null;
  if (coverArticle) {
    articleSchema = generateArticleSchema({
      ...coverArticle,
      title: subcategory.title,
    });

    // Add hasPart for child items
    if (subcategory.items?.length > 0) {
      const childLinks = generateChildLinks(subcategory);
      articleSchema.hasPart = childLinks.map((link) => ({
        "@type": "Article",
        headline: link.title,
        url: link.path,
      }));
    }
  }

  return (
    <>
      <SeoMetadata
        title={`${subcategory?.coverArticle?.metaTitle || subcategory?.title} - Overview`}
        description={subcategory?.coverArticle?.metaDescription?.metaDescription}
      />
      {articleSchema && (
        <script
          type="application/ld+json"
          id="article-schema-lc"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
        />
      )}
    </>
  );
}

export const query = graphql`
  query ($subcategorySlug: String!) {
    contentfulLcSubcategory(slug: { eq: $subcategorySlug }) {
      title
      slug
      coverArticle {
        metaDescription {
          metaDescription
        }
        metaTitle
        ...sharedArticleBody
      }
      items {
        title
        slug
      }
      lc_category {
        slug

        lc_section {
          slug
        }
      }
    }
  }
`;
